import React from 'react'
import Container from 'components/program-marketing/container'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Link, Typography, Box } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import { leagueMarketing } from 'lib/junior-league-utils/routes'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import { HowSectionList } from 'components/program-marketing/how-section-list'

const useStyles = makeStyles(theme => ({
  orange: {
    background: theme.palette.primary.main,
  },
}))

const LeagueStandingSection = ({ teams }) => {
  const classes = useStyles()

  const teamList = teams.map(team => ({
    title: team.name,
    text: (
      <>
        Team {team.name} play in League {team.league.name}.
        <Link
          component={RouterLink}
          to={leagueMarketing(team.league.id)}
          data-testid="standing-page-link"
        >
          {' '}
          View this team's league standings page.
        </Link>
      </>
    ),
    icon: PeopleOutlineIcon,
    iconBg: classes.orange,
  }))

  return (
    <Container data-testid="league-standing-section">
      <Box mb={2}>
        <Typography variant="h3" color="primary">
          Program Leagues and Teams
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="h2">League Standings</Typography>
        <Typography>
          Please select your Team below to view League Standings.
        </Typography>
      </Box>
      <HowSectionList data={teamList} />
    </Container>
  )
}

export default LeagueStandingSection
